import { withIcon } from './withIcon'

export const Heart = withIcon(() => (
  <path d="M10.2586 0.3125C8.9077 0.312616 7.66179 1.03058 7 2.19059C6.33821 1.03058 5.0923 0.312616 3.74138 0.3125C1.67516 0.3125 0 2.20011 0 4.23514C0 9.34646 7 12.9125 7 12.9125C7 12.9125 14 9.34646 14 4.23514C14 2.20011 12.3248 0.3125 10.2586 0.3125Z" />
))
